import React, { Component } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import { withApollo } from 'react-apollo';
import { 
    UPDATE_WHATSAPP_LEAD_HISTORY, 
    GET_WHATSAPP_LEAD_LEVELS, 
    GET_WHATSAPP_CALL_STATUS_TYPES, 
    GET_WHATSAPP_LEAD_STATUS_TYPES 
} from '../../utils/whatsappHelper';

class LeadSidecar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingMetadata: false,
            updating: false,
            message: '',
            error: '',
            
            // Metadata
            leadLevels: [],
            callStatuses: [],
            statusCategories: [],
            
            // Form state
            selectedLevel: '',
            selectedCallStatus: '',
            selectedCategory: '',
            comments: '',
            followupTime: ''
        };
    }

    componentDidMount() {
        this.fetchMetadata();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.contactId !== this.props.contactId) {
            this.setState({
                message: '',
                error: '',
                comments: '',
                followupTime: '',
                selectedLevel: '',
                selectedCallStatus: '',
                selectedCategory: ''
            });
        }
    }

    fetchMetadata = async () => {
        const { employeeId, client } = this.props;
        this.setState({ loadingMetadata: true });
        try {
            const [levelsRes, callRes, catRes] = await Promise.all([
                client.query({ query: GET_WHATSAPP_LEAD_LEVELS, fetchPolicy: 'network-only' }),
                client.query({ query: GET_WHATSAPP_CALL_STATUS_TYPES, fetchPolicy: 'network-only' }),
                client.query({ 
                    query: GET_WHATSAPP_LEAD_STATUS_TYPES, 
                    variables: { employee_id: parseInt(employeeId) },
                    fetchPolicy: 'network-only'
                })
            ]);

            const parse = (str) => {
                if (typeof str !== 'string') return str;
                try { return JSON.parse(str).data || []; } catch(e) { return []; }
            };

            this.setState({
                leadLevels: parse(levelsRes.data.getWhatsAppLeadLevels),
                callStatuses: parse(callRes.data.getWhatsAppCallStatusTypes),
                statusCategories: parse(catRes.data.getWhatsAppLeadStatusTypes),
                loadingMetadata: false
            });
        } catch (error) {
            console.error("Failed to fetch CRM metadata:", error);
            this.setState({ loadingMetadata: false });
        }
    }

    handleSubmit = async () => {
        const { contactId, employeeId, client, onUpdate } = this.props;
        const { selectedCategory, selectedCallStatus, followupTime, comments } = this.state;

        if (!contactId) return;

        this.setState({ updating: true, message: '', error: '' });
        try {
            const result = await client.mutate({
                mutation: UPDATE_WHATSAPP_LEAD_HISTORY,
                variables: {
                    employee_id: parseInt(employeeId),
                    wa_contact_id: parseInt(contactId),
                    lead_status_type_id: selectedCategory ? parseInt(selectedCategory) : null,
                    calling_status_id: selectedCallStatus ? parseInt(selectedCallStatus) : null,
                    followup_time: followupTime || null,
                    comments: comments
                }
            });

            if (result.data.updateWhatsAppLeadHistory?.success) {
                this.setState({ 
                    updating: false, 
                    message: 'Status updated successfully.',
                    comments: '',
                    followupTime: '' 
                });
                if (onUpdate) onUpdate();
            } else {
                this.setState({ updating: false, error: result.data.updateWhatsAppLeadHistory?.message || 'Failed to update.' });
            }
        } catch (error) {
            console.error("Update failed:", error);
            this.setState({ updating: false, error: 'Network error during update.' });
        }
    }

    render() {
        const { contactId, studentName } = this.props;
        const { 
            loadingMetadata, updating, message, error, 
            leadLevels, callStatuses, statusCategories,
            selectedLevel, selectedCallStatus, selectedCategory, comments, followupTime 
        } = this.state;

        if (!contactId) return null;

        return (
            <div className="cc-inspector-form d-flex flex-column h-100 bg-white">
                <style>{`
                    .af-pro-label-sm { font-size: 10px; font-weight: 800; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 8px; display: block; }
                    .af-side-form-control { 
                        font-size: 13px; border-radius: 8px; border: 1px solid #e2e8f0; 
                        padding: 10px 12px; height: auto;
                    }
                    .af-side-form-control:focus { border-color: #0f172a; box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.05); }
                    .form-section-divider { height: 1px; background: #f1f5f9; margin: 20px 0; }
                `}</style>
                
                {message && <Alert variant="success" className="py-2 small border-0 shadow-sm mb-3" style={{backgroundColor: '#f0fdf4', color: '#16a34a'}}>{message}</Alert>}
                {error && <Alert variant="danger" className="py-2 small border-0 shadow-sm mb-3" style={{backgroundColor: '#fef2f2', color: '#dc2626'}}>{error}</Alert>}

                <Form className="flex-fill">
                    <div className="row gx-2">
                        <div className="col-12 mb-3">
                            <label className="af-pro-label-sm">Primary Admission Status</label>
                            <Form.Control 
                                as="select" 
                                className="af-side-form-control"
                                value={selectedCategory}
                                onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                                disabled={loadingMetadata}
                            >
                                <option value="">Identify Category...</option>
                                {statusCategories.map(cat => <option key={cat.id} value={cat.id}>{cat.status_type}</option>)}
                            </Form.Control>
                        </div>
                    </div>

                    <div className="row gx-2">
                        <div className="col-6 mb-3">
                            <label className="af-pro-label-sm">Academic Intent</label>
                            <Form.Control 
                                as="select" 
                                className="af-side-form-control"
                                value={selectedLevel}
                                onChange={(e) => this.setState({ selectedLevel: e.target.value })}
                                disabled={loadingMetadata}
                            >
                                <option value="">Level</option>
                                {leadLevels.map(lvl => <option key={lvl.id} value={lvl.id}>{lvl.level_name}</option>)}
                            </Form.Control>
                        </div>
                        <div className="col-6 mb-3">
                            <label className="af-pro-label-sm">Contact Outcome</label>
                            <Form.Control 
                                as="select" 
                                className="af-side-form-control"
                                value={selectedCallStatus}
                                onChange={(e) => this.setState({ selectedCallStatus: e.target.value })}
                                disabled={loadingMetadata}
                            >
                                <option value="">Outcome</option>
                                {callStatuses.map(st => <option key={st.id} value={st.id}>{st.status_name}</option>)}
                            </Form.Control>
                        </div>
                    </div>

                    <div className="form-section-divider" />

                    <Form.Group className="mb-3">
                        <label className="af-pro-label-sm">Scheduled Re-engagement</label>
                        <Form.Control 
                            type="datetime-local" 
                            className="af-side-form-control"
                            value={followupTime}
                            onChange={(e) => this.setState({ followupTime: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <label className="af-pro-label-sm">Internal Staff Notes</label>
                        <Form.Control 
                            as="textarea" 
                            rows={4} 
                            placeholder="Append contextual staff notes..."
                            className="af-side-form-control"
                            value={comments}
                            onChange={(e) => this.setState({ comments: e.target.value })}
                            style={{resize: 'none', lineHeight: '1.6'}}
                        />
                    </Form.Group>

                    <Button 
                        variant="primary" 
                        className="w-100 af-premium-btn py-2 font-weight-bold cc-animate-fade" 
                        style={{ fontSize: '13px', borderRadius: '10px' }}
                        onClick={this.handleSubmit}
                        disabled={updating}
                    >
                        {updating ? (
                            <><Spinner animation="border" size="sm" className="mr-2" /> SYNCING</>
                        ) : (
                            <><i className="fas fa-save mr-2" /> UPDATE PROFILE</>
                        )}
                    </Button>
                </Form>
                
                <div className="mt-auto pt-4 text-center">
                    <div className="p-3 bg-light rounded-lg border-dashed" style={{border: '1px dashed #cbd5e1'}}>
                        <p className="x-small text-muted mb-0 font-weight-bold" style={{letterSpacing: '0.5px'}}>
                            STUDENT CONTEXT: <span className="text-dark">{studentName}</span>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withApollo(LeadSidecar);
